import LocalImages from "assets/images/local-images";
import Body from "features/shared/styles/typography/Body.styled";
import { Summary } from "features/shared/styles/typography/Summary.styled";
import { FC } from "react";

import ErrorDescription from "./styles/ErrorDescription.styled";
// @ts-expect-error: webpack plugin
import StyledErrorBanner from "./styles/StyledErrorBanner-APP_CLIENT.styled";

interface BannerProps {
  title?: string;
  descriptions: string[];
}

const ErrorBanner: FC<BannerProps> = ({ title, descriptions }) => {
  const images = LocalImages.shared.images;

  return (
    <StyledErrorBanner>
      <img alt="error banner" src={images.icons.banner.error} />
      <div>
        {title ? <Summary>{title}</Summary> : null}
        {descriptions.map((description) => (
          <ErrorDescription key={description}>
            <Body>{description}</Body>
          </ErrorDescription>
        ))}
      </div>
    </StyledErrorBanner>
  );
};

export default ErrorBanner;
